export class DayOfWeek {
    ID: number;
    Name: string;
}

export default DayOfWeek;